
import router from '@/router'

import { AccountService } from '@/services'

const ACCOUNT = JSON.parse(localStorage.getItem('ACCOUNT'))
const accountService = new AccountService()

const state = ACCOUNT
    ? { 
      status: { loggedIn: true }, 
      account: ACCOUNT,
    } : { 
      status: {}, 
      account: null,
    }
const mutations = {
  signinRequest(state, account) {
    state.status = { loggedIn: true }
    state.account = account
  },
  signinSuccess(state, account) {
    state.status = { loggedIn: true }
    state.account = account
  },
  signout(state) {
    state.status = {}
    state.account = null
  },
}
const getters = {
  getToken: (state) => {
    return state.account
  }
}
const actions = {
  signin({ commit }, creds) {
    return new Promise(resolve => {
      accountService.signin(creds, account => {
        if(account.token) {
          commit('signinSuccess', account)
          resolve(account)
        } else {
          resolve(account)
        }
      })
    })
  },
  signout({ commit }) {
    accountService.signout(() => {
      commit('signout')
      router.replace('/login', () => {})
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
